import React from "react";

interface PortraitIconProps {
  className?: string;
}

const PortraitIcon: React.FC<PortraitIconProps> = ({ className }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="none" color="#5c5f67">
    <path d="M4.75 5C4.75 3.20507 6.20507 1.75 8 1.75H16.5C18.2949 1.75 19.75 3.20507 19.75 5V19C19.75 20.7949 18.2949 22.25 16.5 22.25H8C6.20507 22.25 4.75 20.7949 4.75 19V5Z" stroke="currentColor" />
  </svg>
);

export default PortraitIcon;
